import { fetchMethod, postMethod, putMethod, deleteMethod } from "./http.api"

const CarService = {

    adddCAR: async (projectId: string, data: object) => {
        return await postMethod(`/v1/CorrectiveActionRequest/${projectId}`, data)
    },

    // Not yet released in DEV
    fetchAllCARs: async () => {
        return await fetchMethod(`/v1/CorrectiveActionRequest/car`)
    },

    fetchCAR: async (id: string) => {
        return await fetchMethod(`/v1/CorrectiveActionRequest/car/${id}`)
    },

    updateCAR: async (id: string, data: object) => {
        return putMethod(`/v1/CorrectiveActionRequest/${id}`, data)
    },

    deleteCAR: async (id: string) => {
        return await deleteMethod(`/v1/CorrectiveActionRequest/${id}`)
    },
    
    fetchCARSiteIssues: async (oppId: string,recordType: string, programName: string) => {
        return await fetchMethod(`/v1/CorrectiveActionRequest/car/customersites?OpportunityId=${oppId}&OpportunityRecordType=${recordType}&ProgramName=${programName}`)
    },

}

export default CarService;